import { UserRoles } from '@handover/shared-types';
import { projectConfig } from '../config/projectConfig';

// firebase function api url
// Dynamically set based on project configuration
export const BASE_URL = {
  EMULATOR: process.env.REACT_APP_EMULATOR_URL || 'http://127.0.0.1:5001/handoverengine/us-central1/handoverEngine',
  TEST: projectConfig.apiUrl,
};
//
export const METHOD = {
  GET: 'get',
  POST: 'post',
  PUT: 'put',
  DELETE: 'delete',
};
// endpoint
export const END_POINTS = {
  signup: '/signup',
  signin: '/signin',
  signinTwoFactor: '/signin/2fa',
  signedIn: '/signedin',
  resetPassword: '/resetpassword',
  invitePreview: '/invite/preview',
  inviteAccept: '/invite/accept',
  companyRegister: '/company/register',
  companyPlans: '/company/plans',
  companyCheckoutSession: '/company/checkout-session',
  companyMe: '/company/me',
  companyBilling: '/company/billing',
  companySupport: '/company/support',
  companyBillingCheckout: '/company/billing/checkout-session',
  companyBillingCheckoutConfirm: '/company/billing/checkout-confirm',
  companyBillingPortal: '/company/billing/portal-session',
  companyBillingAiTopUpCheckout: '/company/billing/ai-topup/checkout-session',
  companyBillingAiCostReport: '/company/billing/ai-cost-report',
  companyInternalTrial: '/company/internal/trial',
  companyInternalTrialDetail: '/company/internal/trial/:companyId',
  companySupportAccessRequest: '/company/support-access/request',
  companyQuestionnaireTemplate: '/company/questionnaire-template',
  userme: '/user/me',
  userall: '/user/all',
  userupdate: '/user/update',
  userdeletepreview: '/user/delete-preview',
  userdelete: '/user/delete',
  twoFactorSetup: '/user/2fa/setup',
  twoFactorEnable: '/user/2fa/enable',
  twoFactorDisable: '/user/2fa/disable',
};

export const AUTH_END_POINTS = {
  signup: '/signup',
  signin: '/signin',
  signedIn: '/signedin',
  checkUserRole: '/admin/getuser',
  updateRole: '/admin/authorize',
};

export const USER_END_POINTS = {
  userme: '/user/me',
  userall: '/user/all',
  userupdate: '/user/update',
  userdeletepreview: '/user/delete-preview',
  userdelete: '/user/delete',
};

export const HANDOVER_END_POINTS = {
  createhandover: '/handover',
  getarchivedhandovers: '/handover/archive/all',
  restorearchivedhandover: '/handover/archive/:handoverId/restore',
  updatehandover: '/handover/:handoverId',
  deletehandover: '/handover/:handoverId',
  gethandoverdocbyid: '/handover/:handoverId',
  getallhandoverbycreatedbyloggedinuser: '/handover/all/createdby/me',
};

export const HANDOVER_TASK_END_POINTS = {
  gethandovertaskdocbyhandoverid: '/handover/task/:handoverId',
  updatehandovertask: '/handover/task/:handoverId',
  deletehandovertask: '/handover/task/:handoverId/:taskId',
  uploadhandovertaskfile: '/handover/task/upload/:handoverId',
};

export const HANDOVER_COMMENT_END_POINTS = {
  gethandovercommentdocbyhandoverid: '/handover/comment/:handoverId',
  updatehandovercomment: '/handover/comment/:handoverId',
  deletehandovercomment: '/handover/comment/delete/:handoverId',
};

export const HANDOVER_ACCESS_END_POINTS = {
  updateHandoverAccess: '/handover/access/:handoverId',
};

export const AI_END_POINTS = {
  assistant: '/ai/assistant',
  handoverChat: '/ai/handover-chat',
  parser: '/ai/parser',
  summarizer: '/ai/summarizer',
  search: '/ai/search',
};

export const CUSTOMER_SERVICE_NOTIFICATION_END_POINTS = {
  templates: '/customer-service-notifications/templates',
  compose: '/customer-service-notifications/compose',
  send: '/customer-service-notifications/send',
  composed: '/customer-service-notifications/composed',
  logs: '/customer-service-notifications/logs',
};

export const AUTH = {
  AUTHENTICATED: 'AUTHENTICATED',
  UNAUTHENTICATED: 'UNAUTHENTICATED',
};
export const COMPANY_REGISTRATION_ENABLED = process.env.REACT_APP_COMPANY_REGISTRATION_ENABLED === 'true';
export const STRIPE_BILLING_ENABLED = process.env.REACT_APP_STRIPE_BILLING_ENABLED === 'true';
export const STRIPE_BILLING_TEST_MODE = process.env.REACT_APP_STRIPE_BILLING_TEST_MODE === 'true';
export const AI_ASSISTANT_ENABLED = process.env.REACT_APP_AI_ASSISTANT_ENABLED === 'true';
export const THEME_TOGGLE_ENABLED = process.env.REACT_APP_THEME_TOGGLE_ENABLED !== 'false';

export const AUTH_TYPES = {
  logIn: 'logIn',
  signUp: 'signUp',
};

export const USER = 'user';
export const AUTH_COOKIE = 'auth';
export const SUPER_USER = 'superUser';
export const ADMIN = 'admin';
export const SUPER_ADMIN = 'superAdmin';

export const LEVEL3: UserRoles = [SUPER_ADMIN];
export const LEVEL2: UserRoles = [ADMIN, ...LEVEL3];
export const LEVEL1: UserRoles = [SUPER_USER, ...LEVEL2];
export const ALL_LEVEL: UserRoles = [USER, ...LEVEL1];

export const ROLE_HIERARCHY: Record<string, number> = {
  [SUPER_ADMIN]: 3,
  [ADMIN]: 2,
  [SUPER_USER]: 1,
  [USER]: 0,
};

export const getUserLevel = (role: string | undefined): number => {
  return role && ROLE_HIERARCHY[role] !== undefined ? ROLE_HIERARCHY[role] : 0;
};

export const LEVEL1_USER_ROLES = {
  User: { label: 'User', value: 'user' },
  SuperUser: { label: 'Super User', value: 'superUser' },
};
export const LEVEL2_USER_ROLES = {
  ...LEVEL1_USER_ROLES,
  Admin: { label: 'Admin', value: 'admin' },
};

export const LEVEL3_USER_ROLES = {
  ...LEVEL2_USER_ROLES,
  SuperAdmin: {
    label: 'Super Admin',
    value: 'superAdmin',
  },
};
